import script from "./LandingPageDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageDesktop.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageDesktop.vue?vue&type=style&index=0&id=617baa98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617baa98"]])

export default __exports__